import {AppConfig} from '@multipass-common';

export class ShellAppConfig implements AppConfig {
    #gatewayApiUrl: any;

    get gatewayApiUrl() {
        return this.#gatewayApiUrl;
    }

    constructor() {
        this.#gatewayApiUrl = '/api';
    }
}